import React from 'react';
import { Calendar, ChevronRight, Video, Star } from 'lucide-react';

export const EventsList = ({
  events = [],
  selectedEvent,
  selectedRoutine,
  onEventSelect,
  onRoutineSelect
}) => {
  // Helper function to format date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric', 
      year: 'numeric' 
    });
  };

  return (
    <div className="h-full overflow-y-auto">
      {events.map((event) => (
        <div key={event.id} className="border-b border-base-200 last:border-b-0">
          {/* Event Header */}
          <button
            onClick={() => onEventSelect(event)}
            className="w-full px-4 py-3 flex items-center justify-between hover:bg-base-200 transition-colors"
          >
            <div className="flex items-center gap-3">
              <div className="p-2 bg-primary/10 rounded-lg">
                <Calendar className="w-4 h-4 text-primary" />
              </div>
              <div className="text-left">
                <h3 className="text-base-content font-medium">{event.name}</h3>
                <p className="text-sm text-base-content/60">
                  {formatDate(event.date)}
                </p>
              </div>
            </div>
            <ChevronRight className={`w-5 h-5 text-base-content/40 transition-transform ${
              selectedEvent?.id === event.id ? 'rotate-90' : ''
            }`} />
          </button>

          {/* Routines List */}
          {selectedEvent?.id === event.id && (
            <div className="bg-base-200/50">
              {event.routines.map((routine) => (
                <button
                  key={routine.id}
                  onClick={() => onRoutineSelect(routine)}
                  className={`w-full px-4 py-3 flex items-center justify-between hover:bg-base-300 transition-colors ${
                    selectedRoutine?.id === routine.id ? 'bg-primary/10' : ''
                  }`}
                >
                  <div className="flex items-center gap-3">
                    <div className={`p-2 rounded-lg ${
                      selectedRoutine?.id === routine.id 
                        ? 'bg-primary/20' 
                        : 'bg-base-300'
                    }`}>
                      {routine.hasVideo ? (
                        <Video className={`w-4 h-4 ${
                          selectedRoutine?.id === routine.id 
                            ? 'text-primary' 
                            : 'text-base-content/40'
                        }`} />
                      ) : (
                        <Star className={`w-4 h-4 ${
                          selectedRoutine?.id === routine.id 
                            ? 'text-primary' 
                            : 'text-base-content/40'
                        }`} />
                      )}
                    </div>
                    <div className="text-left">
                      <h4 className="text-base-content font-medium">
                        {routine.title}
                      </h4>
                      <p className="text-sm text-base-content/60">
                        {routine.category}
                      </p>
                    </div>
                  </div>
                  {routine.award && (
                    <div className="text-right">
                      <span className="text-xs font-medium px-2 py-1 rounded-full bg-primary/10 text-primary">
                        {routine.award}
                      </span>
                    </div>
                  )}
                </button>
              ))}
            </div>
          )}
        </div>
      ))}

      {events.length === 0 && (
        <div className="flex flex-col items-center justify-center h-full p-6">
          <Calendar className="w-12 h-12 text-base-content/20 mb-2" />
          <p className="text-base-content/60 text-center">
            No events found
          </p>
        </div>
      )}
    </div>
  );
};